import { useEffect } from 'react';
import { Row, Col, Button, Card } from 'reactstrap';
import SlideDrawer from '../../sharedComponents/SlideDrawer/SlideDrawer';
import useDataSuite from './useDataSuite';
import { useSelector } from 'react-redux';
import { HiViewGridAdd } from 'react-icons/hi';
import GrowthOpportunityWidget from './Widgets/GrowthOpportunityWidget';
import { FaTrash } from 'react-icons/fa';
import CompetitiveInsightsWidget from './Widgets/CompetitiveInsightsWidget';
import TargetsByCategoryWidget from './Widgets/TargetsByCategoryWidget';
import LeakageWidget from './Widgets/LeakageWidget';
import OpportunityByStoreWidget from './Widgets/OpportunityByStoreWidget';
import SalesVoidOpportunityWidget from './Widgets/SalesVoidOpportunityWidget';
import LostLocationsWidget from './Widgets/LostLocationsWidget';
import SegmentOverviewWidget from './Widgets/SegmentOverviewWidget';
import { Theme } from '../../config/constants';
import { BsFillBarChartFill } from 'react-icons/bs';
import DataSuiteDetailsSlideDrawer from '../../sharedComponents/SlideDrawer/DataSuiteDetailsSlideDrawer';
import GrowthOpportunitiesHighlightsCard from './DataSuiteCards/GrowthOpportunitiesHighlightsCard';
import PageHeader from '../../sharedComponents/Header/PageHeader';
import ManufacturerSelect from "../../sharedComponents/ManufacturerSelect/ManufacturerSelect";
import FiltersWidget from '../../sharedComponents/Filters/FiltersWidget';
import moment from 'moment';

const GrowthOpportunities = () => {
  const widgetDrawer = useSelector(({datasuite}) => datasuite.widgetDrawer);
  const widgets = useSelector(({datasuite}) => datasuite.widgets);
  const selectedWidgets = useSelector(({user}) => user.dataSuiteWidgets);
    const minDate = useSelector(({dates}) => dates.datasuiteMinDate);
    const fromDate = useSelector(({dates}) => dates.datasuiteFromDate);
    const toDate = useSelector(({dates}) => dates.datasuiteToDate);
    const { getAllData, prechosenFilters, setPrechosenFilters } = useDataSuite.useDataSuite();
    const dateRanges = {
      'Last 30 Days': [moment().subtract(29, 'days'), moment()],
      'Last 2 Months': [moment().subtract(2, 'month'), moment()],
      'Last Year': [moment().subtract(1, 'year'), moment()]
    };

  const {
    getWidgetCatalog,
    getUserWidgetList,
    onClickWidgetDrawerOpen,
    onClickAddWidget,
    onClickReplaceWidget,
    onClickDeleteWidget
  } = useDataSuite.useWidgetControls();

  const getAllWidgetData = (selectedFilters) => {
    setPrechosenFilters(selectedFilters);
    getAllData(selectedFilters);
  };

  useEffect(() => {
    getWidgetCatalog();
    getUserWidgetList();
    getAllWidgetData();
  // eslint-disable-next-line
  }, []);

  // TODO: add actual widgets when they're ready
  const widgetElements = selectedWidgets?.filter(widget => widget.page === 2).map((w, i) => {
    switch (w.name) {
      case ("Growth Opportunities"):
        {return (
        <Card className='col-xxl-6 col-12' key={`widget-container-${w.id}`}>
          <GrowthOpportunityWidget w={w} i={i} prechosenFilters={prechosenFilters}/>
        </Card>);}
      case ("Leakage"):
        {return (
        <Card className='col-xxl-6 col-12' key={`widget-container-${w.id}`}>
            <LeakageWidget w={w} i={i} prechosenFilters={prechosenFilters}/>
        </Card>);}
      case ("Competitive Insights"):
        {return (
        <Card className='col-xxl-6 col-12' key={`widget-container-${w.id}`}>
          <CompetitiveInsightsWidget w={w} i={i} prechosenFilters={prechosenFilters}/>
        </Card>);}
      case ("Targets By Category"):
        {return (
        <Card key={`widget-container-${w.id}`}>
          <TargetsByCategoryWidget w={w} i={i} prechosenFilters={prechosenFilters}/>
        </Card>);}
      case ("Opportunity By Store"):
        {return (
        <Card className='col-xxl-6 col-12' key={`widget-container-${w.id}`}>
            <OpportunityByStoreWidget w={w} i={i} prechosenFilters={prechosenFilters}/>
        </Card>);}
      case ("Sales Void Opportunity"):
        {return (
        <Card className='col-xxl-6 col-12' key={`widget-container-${w.id}`}>
            <SalesVoidOpportunityWidget w={w} i={i} prechosenFilters={prechosenFilters}/>
        </Card>);}
      case ("Lost Locations"):
        {return (
        <Card className='col-xxl-6 col-12' key={`widget-container-${w.id}`}>
            <LostLocationsWidget w={w} i={i} prechosenFilters={prechosenFilters}/>
        </Card>);}
      case ("Segment Overview"):
        {return (
          <Card className='col-xxl-6 col-12' key={`widget-container-${w.id}`}>
            <SegmentOverviewWidget w={w} i={i} prechosenFilters={prechosenFilters}/>
          </Card>
        )}
      default: {
        return (
        <Card key={`widget-container-${w.id}`}>
          <div>Unrecognized widget.
          <Button
              block
              className='py-1 button-label deleteWidgetButton'
              size='sm'
              color='redLight'
              onClick={() => onClickDeleteWidget(w)}>
              <FaTrash color='white' />
          </Button>
          </div>
        </Card>);
      }
    }
  });

  // find all widgets that are not in 'selectedWidgets'
  const unselectedWidgets = widgets.filter((w) => {
    return selectedWidgets ? selectedWidgets.findIndex((sel) => sel.id === w.id) === -1 : false;
  });

  const widgetDrawerElements = unselectedWidgets?.filter(widget => widget.page === 2).map((w) => {
    return (
        <Card className='m-2' key={`widget-preview-${w.id}`}>
        <Row className='p-2'>
            <Col className='d-flex align-items-center text-black main-header text-size-20'>
            {w.name}
            </Col>
            <Col>
            <Button
                className='button-label'
                onClick={() => widgetDrawer.replaceMode ? onClickReplaceWidget(w, widgetDrawer.replaceIndex) : onClickAddWidget(w)}
                block
                color={Theme().colors.accentName}
                size='sm'
            >
                <HiViewGridAdd /> {widgetDrawer.replaceMode ? 'Replace Widget' : 'Add Widget'}
            </Button>
            </Col>
        </Row>
        <Row className='p-2'>
            <Col>
            <img src={w.path} alt='Widget Preview' />
            </Col>
        </Row>
        </Card>
    );
 });

  const widgetDrawerContainer = <div style={{overflowY: 'auto', height: '95%'}}>{widgetDrawerElements?.length > 0 ? widgetDrawerElements : (<div className='mt-3' style={{width: '40vw', textAlign: 'center'}}>No more widgets to add.</div>)}</div>;

  return (
    <>
      <PageHeader title='SalesStream' subtitle="Growth Opportunities" icon={<BsFillBarChartFill fill='url(#icon-gradient)'/>}/>
      <Col className='px-3 py-3'>
        <Row className='label-text text-size-14 d-flex align-items-center mx-auto pb-2'>
          <Col className='ps-0'>
            <div className='main-header text-size-20' style={{lineHeight:'23px', fontWeight:'700',letterSpacing:'.0025em' }}>Today's Highlights</div>
          </Col>
          <Col className="pe-0">
            <ManufacturerSelect />
          </Col>
        </Row>
        <Row xs={1} md={1} lg={1} xl={1} className='label-text text-size-14 d-flex align-items-center card-row g-2'>
          <Card className='px-3'>
            <GrowthOpportunitiesHighlightsCard />
          </Card>
        </Row>
        <Row className='label-text text-size-14 d-flex align-items-center mx-auto pb-2'>
          <Col className='ps-0'>
            <div className='main-header text-size-24'>Data Insights</div>
          </Col>
        </Row>
        <Row xs={1} md={1} lg={1} xl={1} className='label-text text-size-14 d-flex align-items-center card-row g-2'>
          <FiltersWidget
            minDate={minDate}
            fromDate={fromDate}
            toDate={toDate}
            dateRanges={dateRanges}
            onApplyFilters={getAllWidgetData}
            datasetOptionsEnabled={true}
            saveFilterSetsEnabled={false}
            filterSetOptionsEnabled={false}
          />
        </Row>
        <Row className='px-2'>
          {widgetElements}
        </Row>
        <Row>
          <Col className='w-100 px-0'>
            <Button
              className='my-2 py-2 button-label text-size-20'
              style={{width: '100%', color: '#49A4DA', border: '2px dashed #49A4DA', boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.25)', borderRadius: '8px'}}
              onClick={() => onClickWidgetDrawerOpen("Add Widget")}
              block
              size='sm'
            >
              <Row>
                <Col><HiViewGridAdd /></Col>
              </Row>
              <Row>
                <Col>Add Widgets</Col>
              </Row>
            </Button>
          </Col>
        </Row>
        <SlideDrawer title={widgetDrawer.title} className="dataSuiteSlideDrawer" drawerContents={widgetDrawerContainer} />
        <DataSuiteDetailsSlideDrawer title={"N/A"} className="dataSuiteDetailsSlideDrawer" drawerContents={""} prechosenFilters={prechosenFilters}/>
      </Col>
    </>
  )
}

export default GrowthOpportunities;
